"use strict";
/*
 * Created on 05 16 2019
 */

var _classCallCheck = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/classCallCheck");

var _createClass = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/createClass");

var _possibleConstructorReturn = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/possibleConstructorReturn");

var _getPrototypeOf = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/getPrototypeOf");

var _inherits = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/inherits");

Object.defineProperty(exports, "__esModule", {
  value: true
});

var SelloutReleaseItemEvaluation_1 = require("../../model/sellout/SelloutReleaseItemEvaluation");

var SelloutReleaseItemEvaluationConverter_1 = require("./SelloutReleaseItemEvaluationConverter");
/**
 * Implementation of {@link SelloutReleaseItemEvaluationConverter}.
 *
 * @author JMe
 */


var SelloutReleaseItemEvaluationConverterImpl =
/*#__PURE__*/
function (_SelloutReleaseItemEv) {
  _inherits(SelloutReleaseItemEvaluationConverterImpl, _SelloutReleaseItemEv);

  function SelloutReleaseItemEvaluationConverterImpl() {
    _classCallCheck(this, SelloutReleaseItemEvaluationConverterImpl);

    return _possibleConstructorReturn(this, _getPrototypeOf(SelloutReleaseItemEvaluationConverterImpl).apply(this, arguments));
  }

  _createClass(SelloutReleaseItemEvaluationConverterImpl, [{
    key: "toDocument",

    /**
     * @inheritDoc
     */
    value: function toDocument(source, conversions) {
      if (typeof source !== 'object' || source === null) {
        return null;
      }

      var result = {};
      Object.assign(result, {
        expectedSalesAmount: source.expectedSalesAmount ? conversions.fromBigNumber(source.expectedSalesAmount) : null,
        actualSalesAmount: conversions.fromBigNumber(source.actualSalesAmount),
        estimationInPercent: source.estimationInPercent ? conversions.fromBigNumber(source.estimationInPercent) : null,
        estimatedEndDate: source.estimatedEndDate ? conversions.fromDate(source.estimatedEndDate) : null,
        estimatedDays: source.estimatedDays
      });
      return result;
    }
    /**
     * @inheritDoc
     */

  }, {
    key: "toObject",
    value: function toObject(source, conversions) {
      return new SelloutReleaseItemEvaluation_1.SelloutReleaseItemEvaluation(conversions.asObjectOpt(source, 'expectedSalesAmount', function (v) {
        return conversions.toBigNumber(v);
      }), conversions.asObject(source, 'actualSalesAmount', function (v) {
        return conversions.toBigNumber(v);
      }), conversions.asObjectOpt(source, 'estimationInPercent', function (v) {
        return conversions.toBigNumber(v);
      }), SelloutReleaseItemEvaluation_1.SelloutReleaseItemEvaluation.schema.estimatedEndDate.valueOfField(source), SelloutReleaseItemEvaluation_1.SelloutReleaseItemEvaluation.schema.estimatedDays.valueOfField(source));
    }
  }]);

  return SelloutReleaseItemEvaluationConverterImpl;
}(SelloutReleaseItemEvaluationConverter_1.SelloutReleaseItemEvaluationConverter);

exports.SelloutReleaseItemEvaluationConverterImpl = SelloutReleaseItemEvaluationConverterImpl;